import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';
import { SELECT } from '../../../../shared/components/search-header/components/search-header/search-header.component';
import { Cfop } from '../../../regra-fiscal/model/cfop.model';
import { Cstcofins } from '../../../regra-fiscal/model/cstcofins.model';
import { Csticms } from '../../../regra-fiscal/model/csticms.model';
import { Cstipi } from '../../../regra-fiscal/model/cstipi.model';
import { Cstpis } from '../../../regra-fiscal/model/cstpis.model';
import { CfopService } from '../../../regra-fiscal/services/cfop.service';
import { CstCofinsService } from '../../../regra-fiscal/services/cstcofins.service';
import { CstIcmsService } from '../../../regra-fiscal/services/csticms.service';
import { CstIpiService } from '../../../regra-fiscal/services/cstipi.service';
import { CstPisService } from '../../../regra-fiscal/services/cstpis.service';
import { RegraFiscalService } from '../../../regra-fiscal/services/regra-fiscal/regra-fiscal.service';

@Component({
  templateUrl: './fast-regra-fiscal.component.html',
  styleUrls: ['./fast-regra-fiscal.component.scss'],
  providers: [
    RegraFiscalService,
    CstIpiService,
    CstIcmsService,
    CstCofinsService,
    CstPisService,
    CfopService
  ]
})
export class FastRegraFiscalComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;

  is70 = false;
  is90 = false;
  is101 = false;
  is201_202_203 = false;
  is201 = false;
  is900 = false;

  showST = false;
  showAliqReducaoST = true;
  requiredST = true;
  showRequiredReducaoST = false;

  showRequiredReducao = false;
  showAliqReducao = false;

  showAliqDiferimento = false;
  showTipoIpi = false;
  isReadOnly = false;
  isReadOnly201 = false;

  isCRT1 = true;
  isInformativo = true;

  tiposModelo = [
    { viewValue: '55 - NFe', value: 'NFE' },
    { viewValue: '65 - NFCe', value: 'NFCE' },
    { viewValue: 'Ambos (NFe/NFCe)', value: 'NFE_NFCE' }
  ] as SELECT[];

  tiposIpi = [
    { viewValue: 'Alíquota Ad Valorem', value: 'AD_VALOREM' },
    { viewValue: 'Alíquota Específica', value: 'ESPECIFICA' }
  ] as SELECT[];

  modBcOptions = [
    { viewValue: '0 - Margem Valor Agregado (%)', value: 0 },
    { viewValue: '1 - Pauta (valor)', value: 1 },
    { viewValue: '2 - Preço Tabelado Máximo (valor)', value: 2 },
    { viewValue: '3 - Valor da Operação', value: 3 }
  ] as any[];

  modBcStOptions = [
    { viewValue: '0 - Preço Tabelado ou Máximo Sugerido', value: 0 },
    { viewValue: '1 - Lista Negativa (valor)', value: 1 },
    { viewValue: '2 - Lista Positiva (valor)', value: 2 },
    { viewValue: '3 - Lista Neutra (valor)', value: 3 },
    { viewValue: '4 - Marge Valor Agregado (%)', value: 4 },
    { viewValue: '5 - Pauta (valor)', value: 5 }
  ] as any[];

  cstAndcsosnInformativos: SELECT[] = [
    { viewValue: '40 - Isenta', value: '40' },
    { viewValue: '41 - Não tributada', value: '41' },
    { viewValue: '50 - Suspensão', value: '50' },
    {
      viewValue: '60 - ICMS cobrado anteriormente por substituição tributária',
      value: '60'
    },
    {
      viewValue:
        '102 - Tributada pelo Simples Nacional sem permissão de crédito',
      value: '102'
    },
    {
      viewValue:
        '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta',
      value: '103'
    },
    { viewValue: '300 - Imune', value: '300' },
    { viewValue: '400 - Não tributada pelo Simples Nacional', value: '400' },
    {
      viewValue:
        '500 - ICMS cobrado anterirmente por substituição tributária (substituído) ou por antecipação',
      value: '500'
    }
  ];

  constructor(
    protected fb: UntypedFormBuilder,
    protected entityService: RegraFiscalService,
    protected tokenService: TokenService,
    protected cstIpiService: CstIpiService,
    protected cstIcmsService: CstIcmsService,
    protected cstCofinsService: CstCofinsService,
    protected cstPisService: CstPisService,
    protected cfopService: CfopService,
    protected dialogRef: MatDialogRef<FastRegraFiscalComponent>,
    protected snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ],
      aliq_especifica_icms: [
        0,
        [
          Validators.required,
          CustomValidators.validateCurrencyValues(5,2),
          CustomValidators.existSpecialChar(true),
        ]
      ],
      aliq_especifica_icms_st: [
        0,
        [
          CustomValidators.validateCurrencyValues(5,2),
          CustomValidators.existSpecialChar(true),
        ]
      ],
      aliq_reducao_base_st: [
        0,
        [
          CustomValidators.validateCurrencyValues(5,2),
          CustomValidators.existSpecialChar(true),
        ]
      ],
      aliq_reducao_base_icms: [
        0,
        [
          CustomValidators.validateCurrencyValues(5,2),
          CustomValidators.existSpecialChar(true),
        ]
      ],
      aliq_diferimento: [
        0,
        [
          CustomValidators.validateCurrencyValues(5,2),
          CustomValidators.existSpecialChar(true),
        ]
      ],
      indice_difal: [false, [Validators.required]],
      difal_base_dupla: [false, [Validators.required]],
      icms_sob_pis_cofins: [false, [Validators.required]],
      icms_sob_frete: [false, [Validators.required]],
      icms_sob_ipi: [false, [Validators.required]],
      tipo_ipi: [this.tiposIpi[0], [Validators.maxLength(6)]],
      cstipi: [null, [CustomValidators.typeIs('object')]],
      cstcofins: [
        null,
        [Validators.required, CustomValidators.typeIs('object')]
      ],
      csticms: [null, [Validators.required, CustomValidators.typeIs('object')]],
      cstpis: [null, [Validators.required, CustomValidators.typeIs('object')]],
      cfop: [null, [Validators.required, CustomValidators.typeIs('object')]],
      cred_sn: [JSON.parse(localStorage.getItem('dadosFiscais')).cred_sn],
      mod_bc: [
        this.modBcOptions.find(t => t.value === 3).value,
        [Validators.required]
      ],
      mod_bc_st: [
        this.modBcStOptions.find(t => t.value === 4).value,
        [Validators.required]
      ],
      modelo: [
        this.data.pdv ? this.tiposModelo[1].value : this.tiposModelo[0].value,
        [Validators.required]
      ],
      nao_gera_receita: [false, [Validators.required]],
      nao_gera_estoque: [false, [Validators.required]]
    });

    this.verificaCRT();
    this.validarForm();
  }

  onSubmit() {
    this.loading = true;
    const entity = {
      domain_org_id: this.tokenService.getDomain().id,
      ...this.form.value
    };
    entity.cfop_id = entity.cfop.id;
    entity.cstcofins_id = entity.cstcofins.id;
    entity.csticms_id = entity.csticms.id;
    entity.cstipi_id = entity.cstipi ? entity.cstipi.id : null;
    entity.cstpis_id = entity.cstpis.id;
    entity.tipo_ipi =
      this.form.value.cstipi && this.form.value.cstipi.cst === '50'
        ? this.form.value.tipo_ipi.value
        : null;
    delete entity.cst_icms_trabalha_st;
    delete entity.cred_sn;
    delete entity.codigo_cst_icms;
    delete entity.codigo_cfop;
    delete entity.codigo_cst_ipi;
    delete entity.codigo_cst_pis;
    delete entity.codigo_cst_cofins;
    delete entity.cfop;
    delete entity.cstcofins;
    delete entity.csticms;
    delete entity.cstipi;
    delete entity.cstpis;

    if (this.form.valid) {
      this.entityService
        .insert(entity)
        .pipe(filter(result => !!result))
        .subscribe(
          regra => {
            this.loading = false;
            regra.pdv = this.data.pdv;
            this.dialogRef.close(regra);
            this.snackBar.open('Regra fiscal cadastrada com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
          },
          () => {
            this.loading = false;
            this.snackBar.open('Erro ao cadastrar regra fiscal.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }

  verificaCRT() {
    const infoFiscal = JSON.parse(localStorage.getItem('dadosFiscais'));
    this.isCRT1 =
      infoFiscal.crt === 'SIMPLES_NACIONAL' || infoFiscal.crt === 'MEI';
    if (infoFiscal.crt === 'SIMPLES_NACIONAL' || infoFiscal.crt === 'MEI') {
      const idIpi99 = 'f4b33281328ec026408d6d00f9e5d5ca';
      this.cstIpiService.getEntity(idIpi99).subscribe(v => {
        this.form.controls.cstipi.setValue(v);
        // this.form.controls.cstipi.disable();
      });
    }
  }

  validarForm() {
    this.form.controls.csticms.valueChanges.subscribe(v => {
      if (v) {
        const selected = this.cstAndcsosnInformativos.find(opt => {
          return v.cstcsosn === opt.value;
        });
        if (selected) {
          this.isInformativo = true;
        } else {
          this.isInformativo = false;
          this.verificaST(v.cstcsosn);
          if (v.cstcsosn === '20') {
            this.is70 = false;
            this.is101 = false;
            this.is201 = false;
            this.is201_202_203 = false;
            this.showAliqReducao = true;
            this.showAliqReducaoST = false;
            this.showRequiredReducao = true;
            this.showAliqDiferimento = false;
            this.isReadOnly = false;
            this.is90 = false;
            this.is900 = false;

            if (!this.form.value.aliq_reducao_base_icms) {
              this.form.controls.aliq_reducao_base_icms.addValidators(
                Validators.required
              );
              this.form.controls.aliq_reducao_base_icms.markAsTouched();
            }

            this.form.controls.aliq_reducao_base_st.setErrors(null);
            this.form.controls.aliq_diferimento.setErrors(null);

            this.form.controls.aliq_diferimento.markAsTouched();
            this.form.controls.aliq_reducao_base_st.markAsTouched();
            this.form.updateValueAndValidity();
          } else if (v.cstcsosn === '10' || v.cstcsosn === '30') {
            this.is70 = false;
            this.is101 = false;
            this.is201 = false;
            this.is201_202_203 = false;
            this.showRequiredReducao = false;
            this.showAliqReducao = false;
            this.showAliqReducaoST = true;
            this.showAliqDiferimento = false;
            this.isReadOnly = false;
            this.is90 = false;
            this.is900 = false;

            if (!this.form.value.aliq_especifica_icms_st) {
              this.form.controls.aliq_especifica_icms_st.addValidators(
                Validators.required
              );
              this.form.controls.aliq_especifica_icms_st.markAsTouched();
            }

            this.form.controls.aliq_reducao_base_icms.setErrors(null);
            this.form.controls.aliq_reducao_base_st.setErrors(null);
            this.form.controls.aliq_diferimento.setErrors(null);

            this.form.controls.aliq_diferimento.markAsTouched();
            this.form.controls.aliq_reducao_base_icms.markAsTouched();
            this.form.controls.aliq_reducao_base_st.markAsTouched();
            this.form.updateValueAndValidity();
          } else if (v.cstcsosn === '51') {
            this.is70 = false;
            this.is101 = false;
            this.is201 = false;
            this.is201_202_203 = false;
            this.showAliqReducao = true;
            this.showAliqDiferimento = true;
            this.showRequiredReducao = false;
            this.isReadOnly = false;
            this.showAliqReducaoST = false;
            this.is90 = false;
            this.is900 = false;

            this.form.controls.aliq_reducao_base_icms.setErrors(null);
            this.form.controls.aliq_reducao_base_st.setErrors(null);

            this.form.controls.aliq_reducao_base_icms.markAsTouched();
            this.form.controls.aliq_reducao_base_st.markAsTouched();

            if (!this.form.value.aliq_diferimento) {
              this.form.controls.aliq_diferimento.addValidators(
                Validators.required
              );
              this.form.controls.aliq_diferimento.markAsTouched();
            }
            this.form.updateValueAndValidity();
          } else if (v.cstcsosn === '70' || v.cstcsosn === '90') {
            this.is101 = false;
            this.is201 = false;
            this.is201_202_203 = false;
            this.showAliqReducao = true;
            this.showAliqReducaoST = false;
            this.showAliqDiferimento = false;
            this.isReadOnly = false;
            this.is70 = v.cstcsosn === '70';
            this.is90 = v.cstcsosn === '90';
            this.is900 = false;
            this.requiredST = false;

            if (this.is70) {
              this.requiredST = true;
              this.showRequiredReducao = true;
              this.showRequiredReducaoST = false;
              if (!this.form.value.aliq_reducao_base_icms) {
                this.form.controls.aliq_reducao_base_icms.addValidators(
                  Validators.required
                );
                this.form.controls.aliq_reducao_base_icms.markAsTouched();
              }
              if (!this.form.value.aliq_especifica_icms_st) {
                this.form.controls.aliq_especifica_icms_st.addValidators(
                  Validators.required
                );
                this.form.controls.aliq_especifica_icms_st.markAsTouched();
              }
              this.form.updateValueAndValidity();
            } else {
              this.form.controls.aliq_reducao_base_icms.setErrors(null);
              this.form.controls.aliq_diferimento.setErrors(null);
              this.form.controls.aliq_especifica_icms_st.setErrors(null);

              this.form.controls.aliq_diferimento.markAsTouched();
              this.form.controls.aliq_especifica_icms_st.markAsTouched();
              this.form.controls.aliq_reducao_base_icms.markAsTouched();
              this.form.updateValueAndValidity();
            }
          } else if (v.cstcsosn === '101') {
            this.is101 = true;
            this.is70 = false;
            this.is90 = false;
            this.is201 = false;
            this.is201_202_203 = false;
            this.is900 = false;
            this.showRequiredReducao = false;
            this.showAliqReducao = false;
            this.showAliqReducaoST = false;
            this.showAliqDiferimento = false;
            this.isReadOnly = true;

            if (JSON.parse(localStorage.getItem('dadosFiscais')).cred_sn) {
              this.form.controls.cred_sn.setValue(
                JSON.parse(localStorage.getItem('dadosFiscais')).cred_sn
              );
            } else {
              this.form.controls.cred_sn.addValidators(Validators.required);
              this.form.controls.cred_sn.markAsTouched();
            }

            this.form.controls.aliq_reducao_base_icms.setErrors(null);
            this.form.controls.aliq_reducao_base_st.setErrors(null);
            this.form.controls.aliq_diferimento.setErrors(null);

            this.form.controls.aliq_diferimento.markAsTouched();
            this.form.controls.aliq_reducao_base_icms.markAsTouched();
            this.form.controls.aliq_reducao_base_st.markAsTouched();
            this.form.updateValueAndValidity();
          } else if (
            v.cstcsosn === '201' ||
            v.cstcsosn === '202' ||
            v.cstcsosn === '203'
          ) {
            this.is70 = false;
            this.is101 = false;
            this.is201 = v.cstcsosn === '201';
            this.isReadOnly201 = v.cstcsosn === '201';
            this.is201_202_203 = true;
            this.showAliqReducao = false;
            this.showRequiredReducao = false;
            this.showAliqReducaoST = false;
            this.showAliqDiferimento = false;
            this.is90 = false;
            this.is900 = false;

            if (JSON.parse(localStorage.getItem('dadosFiscais')).cred_sn) {
              this.form.controls.cred_sn.setValue(
                JSON.parse(localStorage.getItem('dadosFiscais')).cred_sn
              );
            } else {
              this.form.controls.cred_sn.addValidators(Validators.required);
              this.form.controls.cred_sn.markAsTouched();
            }

            if (!this.form.value.aliq_especifica_icms_st) {
              this.form.controls.aliq_especifica_icms_st.addValidators(
                Validators.required
              );
              this.form.controls.aliq_especifica_icms_st.markAsTouched();
            }

            this.form.controls.aliq_reducao_base_icms.setErrors(null);
            this.form.controls.aliq_reducao_base_st.setErrors(null);
            this.form.controls.aliq_diferimento.setErrors(null);

            this.form.controls.aliq_diferimento.markAsTouched();
            this.form.controls.aliq_reducao_base_icms.markAsTouched();
            this.form.controls.aliq_reducao_base_st.markAsTouched();
            this.form.updateValueAndValidity();
          } else if (v.cstcsosn === '900') {
            this.is900 = true;
            this.showAliqReducaoST = true;
            this.is70 = false;
            this.is101 = false; // exibe a aliq icms ou cred_sn primeiro campo
            this.showAliqReducao = true; // esse com showST mostra o aliq reducao icms segundo campo
            this.showAliqDiferimento = false; // esse com showST mostra o aliq especifica icms st terceiro campo
            this.is201 = false;
            this.isReadOnly201 = false;
            this.isReadOnly = false;
            this.is201_202_203 = false;
            this.is90 = false;
            this.showRequiredReducao = false;
          } else {
            this.is101 = false;
            this.is90 = false;
            this.is900 = false;
            this.is70 = false;
            this.is201_202_203 = false;
            this.is201 = false;
            this.showRequiredReducao = false;
            this.showAliqReducao = false;
            this.showAliqReducaoST = false;
            this.showAliqDiferimento = false;
            this.isReadOnly = false;
            this.form.controls.aliq_reducao_base_icms.setErrors(null);
            this.form.controls.aliq_reducao_base_st.setErrors(null);
            this.form.controls.aliq_diferimento.setErrors(null);
            this.form.controls.aliq_reducao_base_icms.markAsTouched();
            this.form.controls.aliq_reducao_base_st.markAsTouched();
            this.form.controls.aliq_diferimento.markAsTouched();
            this.form.updateValueAndValidity();
          }
        }
      }
    });

    this.form.controls.cstipi.valueChanges.subscribe(v => {
      if (v) {
        if (v.cst === '50') {
          this.showTipoIpi = true;
          this.form.controls.tipo_ipi.addValidators(Validators.required);
          this.form.controls.tipo_ipi.markAsTouched();
        } else {
          this.showTipoIpi = false;
          this.form.controls.tipo_ipi.setErrors(null);
          this.form.controls.tipo_ipi.markAsTouched();
        }

        this.form.updateValueAndValidity();
      }
    });
  }

  verificaST(codigo_cst: string): boolean {
    if (
      codigo_cst === '10' ||
      codigo_cst === '30' ||
      codigo_cst === '70' ||
      codigo_cst === '90' ||
      codigo_cst === '201' ||
      codigo_cst === '202' ||
      codigo_cst === '203' ||
      codigo_cst === '900'
    ) {
      this.showST = true;
      return true;
    } else {
      this.showST = false;
      return false;
    }
  }

  returnClass(): string {
    if (!this.form.value.csticms) return 'col-md-4 mt-2';
    else {
      if (this.is90 || this.is900) return 'col-md-4 mt-2';
      else if (this.is70) return 'col-md-4 mt-2';
      else if (this.is201_202_203 && !this.is201) return 'col-md-4 mt-2';
      else if (this.is201) return 'col-md-4 mt-2';
      else if (this.showAliqReducao && !this.showAliqDiferimento)
        return 'col-md-4 mt-2';
      else if (this.showAliqDiferimento || this.showAliqReducaoST)
        return 'col-md-4 mt-2';
      else return 'col-md-4 mt-2';
    }
  }

  validateNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  cstIpiDisplay = (entity: Cstipi): string => {
    if (entity) {
      return entity.cst + ' - ' + entity.descricao;
    }
    return '';
  };

  cstIcmsdisplay = (entity: Csticms): string => {
    if (entity) {
      return entity.cstcsosn + ' - ' + entity.descricao;
    }
    return '';
  };

  cstCofinsDisplay = (entity: Cstcofins): string => {
    if (entity) {
      return entity.cst + ' - ' + entity.descricao;
    }
    return '';
  };

  cstPisDisplay = (entity: Cstpis): string => {
    if (entity) {
      return entity.cst + ' - ' + entity.descricao;
    }
    return '';
  };

  cfopDisplay = (entity: Cfop): string => {
    if (entity) {
      return entity.cfop + ' - ' + entity.descricao;
    }
    return '';
  };
}
